var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDictionary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03.-Icons/dictionary",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3333333,5 C17.7015232,5 18,5.3052604 18,5.68181818 L18,5.68181818 L18,19.3181818 C18,19.6947396 17.7015232,20 17.3333333,20 L17.3333333,20 L8.33333333,20 C7.04466892,20 6,18.9315886 6,17.6136364 L6,17.6136364 L6,7.38636364 C6,6.06841139 7.04466892,5 8.33333333,5 L8.33333333,5 Z M16.666,16.59 L8.33333333,16.5909091 C7.81556638,16.5909091 7.38970621,16.993352 7.33849622,17.5090684 L7.33333333,17.6136364 C7.33333333,18.178473 7.78104858,18.6363636 8.33333333,18.6363636 L8.33333333,18.6363636 L16.6666667,18.6363636 L16.666,16.59 Z M16.6666667,6.36363636 L8.33333333,6.36363636 C7.81556638,6.36363636 7.38970621,6.76607927 7.33849622,7.28179571 L7.33849622,7.28179571 L7.33333333,7.38636364 L7.33333452,15.4569191 C7.59599707,15.3293061 7.88567024,15.2504042 8.19119317,15.2316279 L8.33333333,15.2272727 L16.666,15.227 L16.6666667,6.36363636 Z",
    id: "Combined-Shape",
    fill: "#3F3E3E",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDictionary);
export default __webpack_public_path__ + "static/media/icon-dictionary.4b84258e6186aab0e28c2ace3994f185.svg";
export { ForwardRef as ReactComponent };